import { ReactNode, useEffect, useMemo, forwardRef, ForwardedRef, useCallback } from 'react';
import { useBottomBar } from '@contexts/BottomBarContext';
import './BottomBar.scss';

type CustomBottomBarProps = {
    children: ReactNode;
    className?: string;
    height?: number;
};

export const CustomBottomBar = forwardRef<HTMLDivElement, CustomBottomBarProps>(
    ({ children, className = '', height }, ref: ForwardedRef<HTMLDivElement>) => {
        const { setCustomBottomBar } = useBottomBar();
        const computedHeight = useMemo(() => height || 90, [height]);

        useEffect(() => {
            document.documentElement.style.setProperty('--bottom-bar-height', `${computedHeight}px`);
        }, [computedHeight]);

        const bottomBarElement = useMemo(() => {
            return (
                <>
                    <div className={`backdrop ${height ? 'open' : ''}`} />
                    <div className={`bottom-bar custom-bottom-bar ${className}`} ref={ref}>
                        {children}
                    </div>
                </>
            );
        }, [children, className, height, ref]);

        const cleanup = useCallback(() => {
            setCustomBottomBar(null);
        }, [setCustomBottomBar]);

        useEffect(() => {
            setCustomBottomBar(bottomBarElement);
            return cleanup;
        }, [bottomBarElement, setCustomBottomBar, cleanup]);

        return null;
    }
);
